<div class="controls d-xs-none d-md-flex">
  <div
    class="title control"
    (click)="setSort('title')"
    [ngClass]="{ active: sorting.field === 'title' }">
    <span>Title</span>
  </div>

  <div
    class="status control d-xs-none d-md-block"
    (click)="setSort('status')"
    [ngClass]="{ active: sorting.field === 'status' }">
    <span>Status</span>
  </div>

  <div
    class="author control d-xs-none d-md-block"
    (click)="setSort('originator')"
    [ngClass]="{ active: sorting.field === 'originator' }">
    <span>Originator</span>
  </div>

  <div
    class="dates control d-xs-none d-md-block"
    (click)="setSort('created_at')"
    [ngClass]="{ active: sorting.field === 'created_at' }">
    <span>Created At</span>
  </div>

  <div
    class="action comments control d-xs-none d-md-block"
    (click)="setSort('comments')"
    [ngClass]="{ active: sorting.field === 'comments' }">
    <span>Comments</span>
  </div>

  <div
    class="action collaborators control d-xs-none d-md-block"
    (click)="setSort('team')"
    [ngClass]="{ active: sorting.field === 'team' }">
    <span>Team</span>
  </div>

  <div
    class="action followers control"
    (click)="setSort('followers')"
    [ngClass]="{ active: sorting.field === 'followers' }">
    Followers
  </div>
</div>
